import { Component } from '@angular/core';

import { ActionsMenuAgRendererComponent, ActionsMenuItem } from '../../covance-ag-grid';
import { UserProfile } from './user-profile';
import { UrlBuilder } from '../../core/url-builder/url-builder';

@Component({
    selector: 'user-profiles-menu-ag-renderer',
    template: require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.html'),
    styles: [require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.scss')],
})
export class UserProfilesActionsMenuAgRendererComponent extends ActionsMenuAgRendererComponent<UserProfile> {

    constructor(
        private readonly urlBuilder: UrlBuilder
    ) {
        super();
    }

    public createMenuItems(userProfile: UserProfile): ActionsMenuItem[] {
        return [
            {
                title: `Edit ${userProfile.firstName} ${userProfile.lastName}'s settings`,
                onClick: () => this.editUserSettings(userProfile)
            }
        ];
    }

    private editUserSettings(userProfile: UserProfile) {
        this.urlBuilder
            .esa()
            .globalPopup()
            .userGeneralSettings(userProfile.userId)
            .navigate();
    }
}